import React from "react"

const SpotifyLogo = () => {
  return (
    <div
      style={{
        display: "inline-block",
        float: "right",
        paddingBottom: "0px"
      }}
    >
      <except-outlook>
        <img
          width="26"
          height="26"
          style={{ width: "26px", height: "26px" }}
          alt="Spotify Logo"
          src={`${process.env.NODE_FUNCTIONS_HOST}/icons?icon=spotify&foreground=ffffff&background=000000&shape=icon-only&v=3`}
        />
      </except-outlook>
    </div>
  )
}

export default SpotifyLogo
